import 'jquery-toast-plugin';

export default {
  init() {

    if ($('.copy-url').length) {
      $('.copy-url').on('click', function () {
        let Url = $(this).find('.copy-url-text');

        console.log(Url);

        Url.attr('type','text');
        Url.select();

        try {
          document.execCommand('copy');
          $.toast({
            text: 'Copied link to your clipboard!',
            hideAfter: 2000,
            icon: 'success',
            loaderBg: '#66B2E3',
            bgColor: '#053E7C',
            textColor: 'white',
          });
        } catch (err) {
          $.toast({
            text: 'An error occured when trying to copy the link.',
            hideAfter: 2000,
            icon: 'success',
            loaderBg: '#e3000d',
            bgColor: 'rgba(209,0,8,0.69)',
            textColor: 'white',
          });
        }

        /* unselect the range */
        Url.attr('type', 'hidden');
        window.getSelection().removeAllRanges();
      });
    }

    if ($('.highlight').length) {
      setTimeout(function () {
        const highlight_offset = $('.highlight').offset().top;
        $('html, body').animate({
          scrollTop: highlight_offset - 180,
        }, 'slow')
      }, 300);
    }

    $('a[href*="#"]')
    // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 150,
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateAtoz.js